/* eslint-disable react/prop-types */
import {Box, Link, Paper, Stack, Typography, useTheme} from '@mui/material';
import {memo} from 'react';
import {Handle, Position} from 'reactflow';
import {useDispatch, useSelector} from 'react-redux';
import {
  setSelectedL1Label,
  setSelectedL2Label,
  setSelectedSubProcess,
  selectL2Label,
  selectL2Reset,
  setL2Reset,
} from 'app/store/appState/appStateSlice';
import {selectAllMaps} from 'app/store/operatingModel/operatingModelSlice';

function TerminalNode({data}) {
  const theme = useTheme();
  const handleStyle = {transform: 'rotate(0deg)', opacity: '0'};
  const dispatch = useDispatch();
  const selectedL2Label = useSelector(selectL2Label);
  const l2Reset = useSelector(selectL2Reset);
  const processMaps = useSelector(selectAllMaps);

  const handleClick = () => {
    const mapLink = processMaps.find((x) => x.id === data.diagram_link_id);
    if (mapLink) {
      if (mapLink?.l2_label === selectedL2Label) {
        dispatch(setL2Reset(!l2Reset));
      } else {
        dispatch(setSelectedSubProcess(mapLink.l1_label_order));
        dispatch(setSelectedL1Label(mapLink.l1_label));
        dispatch(setSelectedL2Label(mapLink.l2_label));
      }
    }
  };

  return (
    <>
      <Box width={'250px'} height={'200px'} display='flex' justifyContent='center' alignItems='center'>
        <Paper
          variant='outlined'
          sx={{
            border: `2px solid ${theme.palette.grey[500]}`,
            borderRadius: '116px',
            borderWidth: '2px',
            width: '180px',
            height: '180px',
            backgroundColor: theme.palette.grey[300],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            '&:hover': {
              boxShadow: ' 0px 0px 10px rgba(0, 0, 0, 0.25)',
            },
          }}
          onClick={() => data.diagram_link && handleClick()}
        >
          <Stack spacing={1.5} p={'10px'} sx={{textAlign: 'center'}}>
            <Typography variant='h6'>{data.description}</Typography>
            {data.diagram_link && <Link variant='h6' color='#000000'>{`Go to steps >`}</Link>}
          </Stack>
        </Paper>
      </Box>

      <Handle id='leftSource' style={handleStyle} type='source' position={Position.Left} />
      <Handle id='topSource' style={handleStyle} type='source' position={Position.Top} />
      <Handle id='rightSource' style={handleStyle} type='source' position={Position.Right} />
      <Handle id='bottomSource' style={handleStyle} type='source' position={Position.Bottom} />

      <Handle id='leftTarget' style={handleStyle} type='target' position={Position.Left} />
      <Handle id='topTarget' style={handleStyle} type='target' position={Position.Top} />
      <Handle id='rightTarget' style={handleStyle} type='target' position={Position.Right} />
      <Handle id='bottomTarget' style={handleStyle} type='target' position={Position.Bottom} />
    </>
  );
}

export default memo(TerminalNode);
